import React, { Fragment } from 'react';
import Head from 'next/head';
import { string } from 'prop-types';

function AmpFacebookEmbed({ url }) {
  if (!url) {
    return null;
  }
  return (
    <Fragment>
      <Head>
        <script
          async
          custom-element="amp-facebook"
          key="amp-facebook-embed"
          src="https://cdn.ampproject.org/v0/amp-facebook-0.1.js"
        />
      </Head>
      <amp-facebook
        width="552"
        height="303"
        layout="responsive"
        data-embed-as={url.includes('video') ? 'video' : 'post'}
        data-href={url}
      />
    </Fragment>
  );
}

AmpFacebookEmbed.propTypes = {
  url: string
};

AmpFacebookEmbed.defaultProps = {
  url: undefined
};

export default AmpFacebookEmbed;
